import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UnitRouteLoadingService {
  private inFlight = 0;

  readonly pending = signal(false);

  begin(): void {
    this.inFlight++;
    this.pending.set(true);
  }

  end(): void {
    this.inFlight = Math.max(0, this.inFlight - 1);
    if (this.inFlight === 0) {
      this.pending.set(false);
    }
  }
}
